var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-nav"},[_c('Tree',{staticClass:"fullheight",attrs:{"nodes":_vm.nodes},model:{value:(_vm.orgUnit),callback:function ($$v) {_vm.orgUnit=$$v},expression:"orgUnit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }